import { cosHttp } from './cos-http'

export interface CosCredentialPayload {
  bucket: string
  region: string
  start_time: string | number
  expired_time: string | number
  session_token: string
  tmp_secret_key: string
  tmp_secret_id?: string
  tmp_secretId?: string
  tmp_secret_key_id?: string
  tmp_secretKeyId?: string
  [key: string]: unknown
}

export interface CosCredentialResponse {
  code: number
  message: string
  data: CosCredentialPayload
}

export function getCosCredential() {
  return cosHttp.get<CosCredentialResponse>('/cos/credential', {
    skipGlobalErrorHandler: true,
  })
}
